const HIDDEN_KEYS = new Set(["semaforo_id", "numero_serie", "equipo", "modelo", "estado_id"]);

const PREFERRED_FIELDS = [
//   { key: "id", label: "Id" },
  { key: "dependencia", label: "Dependencia" },
  { key: "numero_acta", label: "Numero de acta" },
  { key: "estado", label: "Estado", getValue: (afm) => afm?.estado?.descripcion },
  { key: "acta", label: "Acta" },
  { key: "fecha", label: "Fecha" },
  { key: "fecha_creacion", label: "Fecha de creacion" },
  { key: "fecha_actualizacion", label: "Fecha de actualizacion" },
  { key: "dominio", label: "Dominio" },
  { key: "patente", label: "Patente" },
  { key: "titular", label: "Titular" },
  { key: "dni", label: "DNI" },
  { key: "documento", label: "Documento" },
  { key: "tipo_infraccion", label: "Tipo de infraccion" },
  { key: "infraccion", label: "Infraccion" },
  { key: "descripcion", label: "Descripcion" },
  { key: "juzgado", label: "Juzgado" },
  { key: "localidad", label: "Localidad" },
  { key: "provincia", label: "Provincia" },
  { key: "direccion", label: "Direccion" },
  { key: "calle", label: "Calle" },
  { key: "altura", label: "Altura" },
  { key: "latitud", label: "Latitud" },
  { key: "longitud", label: "Longitud" },
];

const formatLabel = (key = "") =>
  key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^./, (char) => char.toUpperCase());

const formatValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  if (typeof value === "boolean") {
    return value ? "Si" : "No";
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return "-";
    }

    const serializedItems = value.map((item) =>
      typeof item === "object" && item !== null ? JSON.stringify(item) : String(item)
    );

    return serializedItems.join(", ");
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
};

const hasVisibleValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return true;
};

export default function AfmDenuncia({ afm }) {
  const preferredEntries = PREFERRED_FIELDS.map((field) => {
    const value = field.getValue ? field.getValue(afm) : afm?.[field.key];

    return {
      key: field.key,
      label: field.label ?? formatLabel(field.key),
      value,
    };
  }).filter(({ value }) => hasVisibleValue(value));

  const usedKeys = new Set(PREFERRED_FIELDS.map(({ key }) => key).concat("estado"));

  const remainingEntries = Object.entries(afm ?? {})
    .filter(([key, value]) => !HIDDEN_KEYS.has(key) && !usedKeys.has(key) && hasVisibleValue(value))
    .map(([key, value]) => ({
      key,
      label: formatLabel(key),
      value,
    }));

  const entries = [...preferredEntries, ...remainingEntries];

  if (entries.length === 0) {
    return null;
  }

  return (
    <div className="col-12 mt-3">
      <div className="border rounded-3 p-3 bg-light-subtle">
        <p className="m-0 mb-3 fw-bold text-primary">Informacion Acta Foto Multa </p>

        <div className="row g-2">
          {entries.map(({ key, label, value }) => (
            <div className="col-12 col-md-6" key={key}>
              <div
                className="h-100 border rounded-2 px-2 py-1 bg-white"
                style={{ fontSize: "0.9rem" }}
              >
                <span className="fw-bold text-primary">{label}: </span>
                <span className="text-break">{formatValue(value)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
